import {Component, OnDestroy, OnInit} from "@angular/core";
import {NgbModal, NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {Observable, Subscription} from "rxjs";
import {UserSessionService} from "../../services/user-session.service";
import {AuthenticationService} from "../../services/authentication.service";
import {CloudApiService} from "../../services/cloud-api.service";
import {SelectLibraryModal} from "../modals/select-library/select-library.modal.component";
import {
    AddPortalLinkModal,
    AddPortalLinkModalComponent
} from "../modals/add-portal-link/add-portal-link.modal.component";
import {PortalLinkDto} from "../../services/dtos/portal-link.dto";
import {Role} from "../../services/dtos/enums/role.enum";

enum State {
    None,
    Loading,
    Ready
}

@Component({
    selector: 'portal',
    template: require('./link-portal.component.html'),
    styles: [require('./link-portal.component.css')],
    providers: [NgbPopoverConfig]
})

export class LinkPortalComponent implements OnInit, OnDestroy {
    states = State;
    state: State = State.None;
    errorMessage: string;

    portalLinks: PortalLinkDto[];
    private librarySubscription: Subscription;

    constructor(
        private userSession: UserSessionService,
        private authenticationService: AuthenticationService,
        private cloudApiService: CloudApiService,
        private selectLibraryModal: SelectLibraryModal,
        private addPortalLinkModal: AddPortalLinkModal,
        private modalService: NgbModal,
        config: NgbPopoverConfig
    ) {
        config.placement = 'left';
        config.triggers = 'hover';
    }

    public ngOnInit(): void {
        this.librarySubscription = this.userSession.library.subscribe(library => {
            this.state = State.Loading;

            if (library) {
                this.updateLinks();
                this.state = State.Ready;
            }
            else if (!this.userSession.libraryId && this.authenticationService.authenticated)
                this.selectLibraryModal.open();
        })
    }

    public ngOnDestroy(): void {
        this.librarySubscription.unsubscribe();
    }

    public updateLinks(showLoading: boolean = true): void {
        this.errorMessage = null;
        if (showLoading)
            this.state = State.Loading;

        this.getLinks().subscribe(() => {
            this.state = State.Ready;
        })
    }

    public delete(linkId: number): void {
        this.errorMessage = null;
        this.deleteLink(linkId).subscribe(() => {
            this.updateLinks();
        })
    }

    private deleteLink(linkId: number): Observable<boolean> {
        return this.cloudApiService.deletePortalLink(linkId)
            .catch(error => this.handleError(error));
    }

    private getLinks(): Observable<boolean> {
        return this.cloudApiService.getPortalLinks()
            .map(links => {
                this.portalLinks = links;
                return true;
            })
            .catch(error => this.handleError(error))
    }

    private handleError(error: any): Observable<any> {
        this.errorMessage = error;
        this.state = State.None;
        return Observable.throw(error);
    }

    private showAddLinkForm() {
        this.modalService.open(AddPortalLinkModalComponent).result
            .then(() => {
                this.updateLinks();
            })
            .catch(() => {});
    }

    canDeleteLinks(): boolean {
        return this.authenticationService.isInLibraryRole(this.userSession.libraryId ,Role.UserManagement);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/link-portal/link-portal.component.ts